/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{position:relative;max-width:1024px;margin:0 auto}.controls[_ngcontent-%COMP%]{position:absolute;top:22px;right:50px}.controls[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-right:1em}@media print{.container[_ngcontent-%COMP%]{padding:0}.controls[_ngcontent-%COMP%]{display:none}}"];
export { styles as styles };
